const styles = {
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  icon: {
    color: 'primary.white',
  },
};

export default styles;
